import { UserKind } from "01Data/Account";
import { AppContext } from "01Data/AppData";
import Footer from "04UserPages/99Parts/Footer";
import Header from "04UserPages/99Parts/Header";
import SideBar from "04UserPages/99Parts/SideBar";
import "97Parts/PasswordBoxStyle.css";
import { Typography, TypographyProps, styled } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";

const PageTitle = styled(Typography)<
  TypographyProps<"h2", { component: "h2" }>
>(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    fontSize: "1.2rem",
    marginBottom: theme.spacing(1),
  },
  [theme.breakpoints.up("sm")]: {
    fontSize: "1.6rem",
    marginBottom: theme.spacing(2),
  },
  color: theme.palette.grey[800],
}));

const AppBarSpacer = styled("div")(({ theme }) => ({
  appBarSpacer: theme.mixins.toolbar,
}));

const Content = styled("main")(({ theme }) => ({
  overflow: "display",
  paddingBottom: theme.spacing(4),
  [theme.breakpoints.down("sm")]: {
    paddingTop: theme.spacing(2),
  },
  [theme.breakpoints.up("sm")]: {
    paddingTop: theme.spacing(3),
  },
}));

type Props = {
  children: any;
  title: string;
};

const PageTemplate = (props: Props) => {
  const a = useContext(AppContext).account;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [IsLogin, setIsLogin] = useState(false);

  const IsQualifiedUser = (kind: UserKind) => {
    switch (kind) {
      case "administrator":
      case "sub_admin":
      case "manager":
      case "user":
        return true;
      default:
        return false;
    }
  };

  useEffect(() => {
    a.IsLogin(IsQualifiedUser)
      .then(() => {
        setIsLogin(true);
      })
      .catch((err: any) => {
        console.log("資格情報エラー");
        console.error(err);
        const id = searchParams.getAll("id");
        if (
          0 <= location.pathname.indexOf("/devices/register") &&
          0 < id.length
        ) {
          // 登録時未ログイン
          sessionStorage.setItem(
            "redirect",
            `${location.pathname}?id=${id[0]}`
          );
        }
        navigate("/login/");
      });
  }, [a, navigate, location, searchParams]);

  if (!IsLogin) {
    return null;
  }

  return (
    <>
      <Header open={open} setOpen={setOpen} />
      <SideBar open={open} setOpen={setOpen} />
      <Content
        sx={{
          paddingLeft: { xs: "5px", sm: "25px" },
          paddingRight: { xs: "5px", sm: "25px" },
        }}
      >
        <AppBarSpacer />
        {props.title ? (
          <PageTitle component="h2" variant="h5" color="inherit" noWrap>
            {props.title}
          </PageTitle>
        ) : null}
        {props.children}
      </Content>
      <Footer />
    </>
  );
};

export default PageTemplate;
